"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNetworkQuality = void 0;
const syntheticNetworkQuality_1 = require("./synthetic/syntheticNetworkQuality");
const prodNetworkQualitySDK_1 = require("./prodNetworkQualitySDK");
const R = __importStar(require("ramda"));
/**
   * Routes the measurement mode to it's related method.
   *
   * @param {measurementMode} mode  measurementMode
   *
   * @returns {Observable | null} Observable
   */
function createNetworkQuality(mode, baseUrl, apiKey, options) {
    const logger = options.logger;
    if (R.isNil(options.dataOverride)) {
        logger.info(`createNetworkQuality. Server data didn't override.`);
    }
    else {
        logger.info(`createNetworkQuality. Server data overrode.`, options.dataOverride);
    }
    switch (mode) {
        case syntheticNetworkQuality_1.MeasurementMode.Production:
            return new prodNetworkQualitySDK_1.ProdNetworkQualitySDK(baseUrl, apiKey, options);
        default:
            return syntheticNetworkQuality_1.SyntheticNetworkQualitySDK.create(mode, logger, getSyntheticInterval(options.clientQueryString), options.dataOverride);
    }
}
exports.createNetworkQuality = createNetworkQuality;
const getSyntheticInterval = (clientQueryString) => {
    if (!R.isNil(clientQueryString)) {
        if (clientQueryString.includes("&pacer")) {
            return 0;
        }
    }
    return 0.1;
};
//# sourceMappingURL=createNetworkQuality.js.map